import React from 'react';
import PropTypes from 'prop-types';

import { LAYOUT } from '../Layout/enums';
import Button from '../Button';

import './FeaturedOffering.css';
import VideoOrImage from '../VideoOrImage';
import ComingSoonLabels from '../ComingSoonLabels';


const FeaturedOffering = (props) => {
  const {
    layout,
    offering,
  } = props;
  let playImage = 'large';
  let featLabelStyle = 'featLabelDesk';
  let featNameStyle = 'featNameDesk';
  let detailBtnStyle;
  switch (layout) {
    case LAYOUT.TAB:
      playImage = 'medium';
      detailBtnStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 225,
        marginLeft: 40,
        marginTop: '56%',
        fontSize: 20,
        zIndex: 10,
      };
      break;
    case LAYOUT.MOB:
      playImage = 'small';
      featLabelStyle = 'featLabelMob';
      featNameStyle = 'featNameMob';
      detailBtnStyle = {
        fontSize: 20,
        margin: '10px auto',
        zIndex: 10,
      };
      break;
    default:
      detailBtnStyle = {
        position: 'absolute',
        left: 50,
        bottom: 42,
        width: 285,
        fontSize: 24,
        zIndex: 10,
      };
      break;
  }
  return (
    <div styleName="featOffer">
      <div styleName={featLabelStyle}>Featured Offer</div>
      <div styleName={featNameStyle}>{offering.name} {<ComingSoonLabels offering={offering} />}</div>
      <div styleName="featVideoDesk">
        {layout !== LAYOUT.MOB ?
          <Button
            style={detailBtnStyle}
            to={`/offers/${offering.id}`}
          >View Details
          </Button> : null}
        <VideoOrImage
          asset={offering.assets && offering.assets[0]}
          playBtnSize={playImage}
        />
      </div>
      {layout === LAYOUT.MOB ?
        <Button
          style={detailBtnStyle}
          to={`/offers/${offering.id}`}
        >View Details
        </Button> : null}
    </div>);
};

FeaturedOffering.propTypes = {
  layout: PropTypes.number.isRequired,
  offering: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    assets: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired,
      previewImageUrl: PropTypes.string,
      type: PropTypes.string,
      title: PropTypes.string,
    })),
  }).isRequired,
};

export default FeaturedOffering;



// WEBPACK FOOTER //
// ./src/components/OfferingList/FeaturedOffering.js